import React from "react";
import { Box, Grid } from "@material-ui/core";
import { BarChartMetricPanel } from "../BarChartMetricPanel";
import { PaperMetricContainer } from "../PaperMetricContainer";
import { DataEntryMetricPanel } from "../DataEntryMetricPanel";
import { useDashboardContext } from "../../DashboardContext";
import { FilledBedDaysMetricPanel } from "../FilledBedDaysMetricPanel";
import { DischargeReasonsMetricPanel } from "../DischargeReasonsMetricPanel";

export const metricIds = [
  "cinsFinsResidentialIntakesDataEntry",
  "cinsFinsResidentialDischargesDataEntry",
  "cinsFinsResidentialDataEntry",
  "cinsFinsResidentialFilledBedDays",
  "cinsFinsResidentialIntakesAndExits",
  "cinsFinsResidentialDischargeReasons",
] as const;

export type ResidentialMetricsDto = {
  [metricId in typeof metricIds[number]]: any;
};

interface Props {
  metrics?: ResidentialMetricsDto;
  isLoading: boolean;
}

export const CinsFinsResidentialDashboardMetrics: React.FC<Props> = ({
  metrics,
  isLoading,
}) => {
  const { provider } = useDashboardContext();

  return (
    <>
      <Grid item sm={12} md={4}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          style={{ width: "100%" }}
        >
          <Box style={{ paddingBottom: 16 }}>
            <PaperMetricContainer>
              <DataEntryMetricPanel
                intakesMetric={metrics?.cinsFinsResidentialIntakesDataEntry}
                dischargesMetric={
                  metrics?.cinsFinsResidentialDischargesDataEntry
                }
                isLoading={isLoading}
              />
            </PaperMetricContainer>
          </Box>
          <Box>
            <PaperMetricContainer>
              <DischargeReasonsMetricPanel
                metric={metrics?.cinsFinsResidentialDischargeReasons}
                isLoading={isLoading}
              />
            </PaperMetricContainer>
          </Box>
        </Box>
      </Grid>
      <Grid item sm={12} md={8}>
        <Box
          display={"flex"}
          flexDirection={"column"}
          style={{ width: "100%", height: "100%" }}
        >
          <Box style={{ paddingBottom: 16 }}>
            <PaperMetricContainer>
              <FilledBedDaysMetricPanel
                metric={metrics?.cinsFinsResidentialFilledBedDays}
                provider={provider}
                isLoading={isLoading}
              />
            </PaperMetricContainer>
          </Box>
          <Box style={{ paddingBottom: 16 }}>
            <PaperMetricContainer>
              <BarChartMetricPanel
                metric={metrics?.cinsFinsResidentialIntakesAndExits}
                labelMap={{ intakes: "Intakes", discharges: "Discharges" }}
                isLoading={isLoading}
              />
            </PaperMetricContainer>
          </Box>
        </Box>
      </Grid>
    </>
  );
};
